import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios"; 
import { API_BASE_URL } from "../config";
import "../styles/Categories.css";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        console.log("Fetching from:", `${API_BASE_URL}/categories`);
        const response = await axios.get(`${API_BASE_URL}/categories`);
        setCategories(response.data);
      } catch (err) {
        setError(err.response ? err.response.data.message : err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="categories">
      <div className="category-grid">
        {categories.map((category) => (
          <Link
            to={`/category/${category.id}`}
            key={category.id}
            className="category-card"
            style={{ backgroundImage: `url(${API_BASE_URL}${category.image})` }}
            aria-label={`Ir a la categoría ${category.name}`}
          >
            <div className="category-content">
              <h2 className="category-name">{category.name}</h2>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Categories;
